import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ActivityReasonCategory } from 'types/activity'
import { ActivityLogPopupOptions } from './hooks'

export interface FormData {
  reason?: string
  reasonCategory?: ActivityReasonCategory
  zendeskTicket?: string
}

export interface ActivityLogPopupState {
  open: boolean
  contentText?: string
  onCancel?: () => void
  onSubmit?: (formData: FormData) => void
  required: boolean
}

const initialState: ActivityLogPopupState = {
  open: false,
  contentText: undefined,
  onCancel: undefined,
  onSubmit: undefined,
  required: false,
}

const activityLogPopupSlice = createSlice({
  name: 'activityLogPopup',
  initialState,
  reducers: {
    openActivityLogPopup(
      state,
      action: PayloadAction<ActivityLogPopupOptions>
    ) {
      state.open = true
      state.contentText = action.payload.contentText
      state.onCancel = action.payload.onCancel
      state.onSubmit = action.payload.onSubmit
      state.required = action.payload.required
    },
    closeActivityLogPopup(state) {
      state.open = false
      state.contentText = undefined
      state.onCancel = undefined
      state.onSubmit = undefined
      state.required = false
    },
  },
})

export const { openActivityLogPopup, closeActivityLogPopup } =
  activityLogPopupSlice.actions
export default activityLogPopupSlice.reducer
